import React from 'react'
import { Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core'

export default function BlastSendModal({
	mode,
	onClose,
	onConfirm,
	travelerCount,
	submitting,
	confirmDisabled = false,
	scheduledTimezone,
	scheduleLocalValue,
	scheduleError,
	onScheduleChange,
}) {
	const isSendNow = mode === 'now'

	return (
		<Modal
			opened={mode !== null}
			onClose={() => {
				if (!submitting) onClose()
			}}
			title={isSendNow ? 'Confirm Blast Send' : 'Schedule Blast Send'}
			closeOnClickOutside={!submitting}
			closeOnEscape={!submitting}
			withCloseButton={!submitting}
			transitionProps={{ duration: 0 }}
			centered
		>
			<Stack spacing='sm'>
				{isSendNow ? (
					<Text>
						Are you sure you would like to send now to {travelerCount}{' '}
						{travelerCount === 1 ? 'traveler' : 'travelers'}?
					</Text>
				) : (
					<>
						<Text size='sm' c='dimmed'>
							This blast will send in timezone: {scheduledTimezone}
						</Text>
						<TextInput
							type='datetime-local'
							label='Send At'
							value={scheduleLocalValue}
							error={scheduleError}
							disabled={submitting}
							onChange={(event) => onScheduleChange(event.currentTarget.value)}
						/>
					</>
				)}
				<Group>
					<Button variant='default' onClick={onClose} disabled={submitting}>
						Cancel
					</Button>
					<Button
						onClick={onConfirm}
						loading={submitting}
						disabled={confirmDisabled || submitting}
					>
						{isSendNow ? 'Send Now' : 'Confirm Schedule'}
					</Button>
				</Group>
			</Stack>
		</Modal>
	)
}
